<template>
  <!-- company-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展商管理</BreadcrumbItem>
          <BreadcrumbItem>详情页</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{ queryData.exhibitorName }}</div>
        <!-- <p style="line-height:40px;color:#808080;font-size:12px;">展会相关的基础数据设置</p> -->
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.go(-1)">
          <span>返回</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" v-model="showTabs">
        <TabPane label="基本信息" name="1">
          <comm1
            ref="hostSetSupply"
            v-if="String(showTabs) === '1'"
            @switchBrand="switchBrand"
          />
        </TabPane>
        <TabPane label="会刊管理" name="2">
          <comm2
            ref="hostSetSupply"
            v-if="String(showTabs) === '2' && list[0]"
            :timeValue="
              list[0].name == 'JournalFree.SubmitDeadline' ? list[0].value : ''
            "
          />
        </TabPane>
        <TabPane label="展品信息管理" name="3">
          <comm3
            ref="hostSetSupply"
            v-if="String(showTabs) === '3' && list[1]"
            :timeValue="
              list[1].name == 'Product.SubmitDeadline' ? list[1].value : ''
            "
          />
        </TabPane>
        <TabPane label="楣板信息管理" name="4">
          <comm4
            ref="hostSetSupply"
            v-if="String(showTabs) === '4' && list[2]"
            :timeValue="
              list[2].name == 'Lintel.SubmitDeadline' ? list[2].value : ''
            "
          />
        </TabPane>
        <TabPane label="展商胸卡管理" name="5">
          <comm5
            ref="hostSetSupply"
            v-if="String(showTabs) === '5' && list[3]"
            :timeValue="
              list[3].name == 'Card.SubmitDeadline' ? list[3].value : ''
            "
          />
        </TabPane>
        <TabPane label="会刊广告管理" name="6">
          <comm6
            ref="hostSetSupply"
            v-if="String(showTabs) === '6' && list[4]"
            :timeValue="
              list[4].name == 'JournalAdvert.SubmitDeadline'
                ? list[4].value
                : ''
            "
          />
        </TabPane>
        <TabPane label="标展搭建变更管理" name="7">
          <comm7
            ref="hostSetSupply"
            v-if="String(showTabs) === '7' && list[5]"
            :timeValue="
              list[5].name == 'SceneAdvert.SubmitDeadline' ? list[5].value : ''
            "
          />
        </TabPane>
        <TabPane label="租凭管理" name="8">
          <comm8
            ref="hostSetSupply"
            v-if="String(showTabs) === '8' && list[6]"
            :timeValue="
              list[6].name ==
              'RentedFurnitureAndTelecommunicationsService.SubmitDeadline'
                ? list[6].value
                : ''
            "
          />
        </TabPane>
        <TabPane label="展台拆除/安装管理" name="9">
          <comm9
            ref="hostSetSupply"
            v-if="String(showTabs) === '9' && list[7]"
            :timeValue="
              list[7].name ==
              'DemolitionBoothAndInstallationConstruction.SubmitDeadline'
                ? list[7].value
                : ''
            "
          />
        </TabPane>
        <TabPane label="回执表管理" name="10">
          <comm10
            ref="hostSetSupply"
            v-if="String(showTabs) === '10' && list[8]"
            :timeValue="
              list[8].name == 'StandardBoothConstructionChange.SubmitDeadline'
                ? list[8].value
                : ''
            "
          />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
  
<script>
import comm1 from "../components/com_a.vue";
import comm2 from "../components/com_b.vue";
import comm3 from "../components/com_c.vue";
import comm4 from "../components/com_d.vue";
import comm5 from "../components/com_e.vue";
import comm6 from "../components/com_f.vue";
import comm7 from "../components/com_g.vue";
import comm8 from "../components/com_h.vue";
import comm9 from "../components/com_i.vue";
import comm10 from "../components/com_j.vue";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "host-set",
  data() {
    return {
      showTabs: "1",
      show: false,
      list: [],
      infoData: {},
      queryData: {},
    };
  },
  components: {
    comm1,
    comm2,
    comm3,
    comm4,
    comm5,
    comm6,
    comm7,
    comm8,
    comm9,
    comm10,
  },
  computed: {
    queryId() {
      return this.$route.query.id;
    },
  },
  created() {
    this.changeTab();
    this.init();
    // this.initInfo();
  },
  methods: {
    ...mapActions({
      setManageSettingQ: "hostSetModule/setManageSettingQ", //获取
      exhibitorAsync: "hostSetModule/exhibitorAsync", //获取
    }),
    async init() {
      let opt = {
        providerName: "Global",
        names: [
          "JournalFree.SubmitDeadline",
          "Product.SubmitDeadline",
          "Lintel.SubmitDeadline",
          "Card.SubmitDeadline",
          "JournalAdvert.SubmitDeadline",
          "SceneAdvert.SubmitDeadline",
          "RentedFurnitureAndTelecommunicationsService.SubmitDeadline",
          "DemolitionBoothAndInstallationConstruction.SubmitDeadline",
          "StandardBoothConstructionChange.SubmitDeadline",
        ],
      };
      let res = await this.setManageSettingQ(opt);
      if (res) {
        this.list = res;
      }
    },
    async initInfo() {
      this.queryData = await this.exhibitorAsync(this.queryId);
      sessionStorage.setItem("sessData", JSON.stringify(this.queryData));
    },

    changeTab() {
      if (this.$route.query.tab) {
        this.showTabs = this.$route.query.tab;
      }
    },
    switchBrand(name) {
      this.showTabs = name;
    },
    showAdd(name) {
      this.$refs[name].showAdd();
    },
  },
};
</script>
  
<style scoped lang="scss">
.civ {
  .header-tool {
    padding: 18px 25px 0 35px;
  }
}
</style>
  